export const SELL_OFFER_V2 = '/cpq/offers/v2/new';

export const CREATE_CUSTOMER = '/customer/customer-accounts';

export const CENTRALIZED_LOGGER_CUSTOMER =
  '/api/v1/centralized-logger/logs/customer';
export const CENTRALIZED_LOGGER_CORRELATION =
  '/api/v1/centralized-logger/logs/correlation';

export const DEFAULT_OFFER_CONFIG = '/default/ips-offer-config';
export const DEFAULT_PRODUCT_CATALOG = '/default/ips-product-catalog';

export function getSellOfferEndpoint(offerCode) {
  return `/default/ips-sell-offer/${offerCode}`;
}

export function getContactsEndpoint(customerAccountId) {
  return `/customer/customer-accounts/${customerAccountId}/contacts`;
}

export function getProvisioningContactsEndpoint(customerAccountId) {
  return `/customer/customer-accounts/${customerAccountId}/contacts?type=provisioning`;
}

export function getIPSObligationsEndpoint(avataxId) {
  return `/api/v1/account/${avataxId}/obligations?$include=entitlements`;
}

export function deprovisionOrphanedAccountEndpoint(avataxId) {
  return `/delivery/avatax/${avataxId}/deprovision`;
}

export const EVENTS_PROVISION = '/api/v1/account/events/provision';

export const ACCOUNT_USAGE = '/api/v1/account/usage';

export const SPECIAL_SERVICES =
  '/api/v1/account/subscriptions/specialServiceTypes';
